module.exports = __webpack_public_path__ + "static/img/公司10.a33bc95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司10.jpg
// module id = 2jlQ
// module chunks = 1